(function ($) {
    $('img[src$=".svg"]').inlineSVG({
        allAfter: function () {
            
            $('.region').click(function (e) {
                e.preventDefault();
                $(".popup-map").fadeOut(500);
                $("#popup-" + $(this).attr('id')).fadeIn(500);
            });

            /*$('path').click(function (e) {
                alert($(this).parent().html());
            });*/
        }
    });

    $(".popup-map .close").click(function () {
        $(".popup-map").fadeOut(500);
    });
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/vendor/onyx-map.js